/* eslint-disable no-param-reassign */
const _ = require('lib/underscore')
const DialogView = require('./dialog_view')
const log = require('log').create('dialog', 'alert') // eslint-disable-line


function alertDialog(html, options = {}) {
    if (! html) throw new Error('Dialog.alert requires an html string')

    if (html.indexOf('</p>') < 0) html = `<p>${html}</p>`

    options.html = html

     
    let alert_dialog

    _.defaults(options, {
        width: 350,
        click_overlay_to_close: false,
        close_button: false,
        glyph: 'attention',
        buttons: [
            {
                text: 'OK',
                default: true,
                color: 'dark primary',
                className: 'fullwidth',
                onClick() {
                    alert_dialog.close()
                },
            },
        ],
    })

    alert_dialog = new DialogView(options)

    return alert_dialog
}

module.exports = alertDialog
